import {
  IsOnWishlistDocument,
  type IsOnWishlistQuery,
} from '@data-access/lib/gql/wishlists/documents'
import { getGraphqlQueryKey, useGraphQL } from '@data-access/lib/graphql-query'
import { useQueryClient } from '@tanstack/react-query'

export function useIsOnWishlist() {
  const { data } = useGraphQL(IsOnWishlistDocument, undefined, { select })

  const isOnWishlist = (
    id: string | number,
    type: 'accommodation' | 'experience' | 'beachSection' | 'bike'
  ) =>
    data?.some(
      ({ productId, productType }) => productId === id.toString() && productType === type
    ) ?? false

  return { isOnWishlist }
}

const select = (data: IsOnWishlistQuery) => data.getWishlists.flatMap(wishlist => wishlist.items)

export const useInvalidateIsOnWishlist = () => {
  const queryClient = useQueryClient()
  return () => queryClient.invalidateQueries({ queryKey: getGraphqlQueryKey(IsOnWishlistDocument) })
}
